/**
 * @description: logger is type ILogger from 'js-logger' module
 */
export type LoggerType = {
  log: (message: unknown) => void;
  error: (message: unknown) => void;
  verbose: (message: unknown) => void;
};
